export const TIMESHEET_DETAILS_TAB_ID="Timesheet-Items";